import React, { useEffect } from 'react';
import { isEmpty } from 'lodash';
import { Container } from '@fiverr-private/layout_components';
import { theme } from '@fiverr-private/theme';
import { useTabContext } from '../../TabContext';
import useIndicatorStyles from './hooks/useGetStyles';
import { getStylingProps } from './styles';
import { IndicatorProps } from './types';

const Indicator = ({ variant, placement, orientation, isFocusedRef, tabListRef }: IndicatorProps) => {
  const styles = useIndicatorStyles(orientation, tabListRef);
  const stylingProps = getStylingProps(variant, placement, orientation);
  const { setIsIndicatorRendered } = useTabContext();

  useEffect(() => {
    setIsIndicatorRendered(true);
  }, [setIsIndicatorRendered]);

  return (
    <Container
      position="absolute"
      zIndex={variant === 'default' ? '1' : undefined}
      transition={isFocusedRef?.current ? `all ${theme.animationDuration.moderate3}` : undefined}
      visibility={isEmpty(styles) ? 'hidden' : undefined}
      {...styles}
      {...stylingProps}
    />
  );
};

Indicator.displayName = 'Indicator';
export default Indicator;
